import { useCallback, useContext } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { isIri } from '@utils/iri'
import { setProtectionMeansIsVisibleIndex } from '@services/riskMapModal'
import { useAppSelector } from '@hooks/useAppSelector'
import { TopControllersContext } from '@modals/RiskMapModal'
import { useLazyGetDangersSearchedProtectionMeansQuery } from '@services/protectionMeans'
import { Option } from '@organs/Select'
import { getEventName } from '@modals/RiskMapModal/Dangers/nameUtils'
import { useAppDispatch } from '@hooks/useAppDispatch'

const useProtectionMeansModal = ({ watch }: UseFormReturn, index: number) => {
  const dispatch = useAppDispatch()

  const { enabledAutoAddSiz } = useContext(TopControllersContext)

  const protectionMeansState = useAppSelector(
    (state) => state.riskMapModal.selectedProtectionMeansForms[index]
  )

  const event: Option | undefined = watch(getEventName(index))

  const [
    getDangersSearchedProtectionMeansQuery,
    { isLoading: protectionMeansIsLoading },
  ] = useLazyGetDangersSearchedProtectionMeansQuery()

  const openProtectionMeans = useCallback(async () => {
    if (
      enabledAutoAddSiz &&
      !protectionMeansState?.prefilled &&
      isIri(event?.value)
    ) {
      await getDangersSearchedProtectionMeansQuery({
        event: event?.value,
        modalIndex: index,
      })
    }

    setTimeout(() => {
      dispatch(setProtectionMeansIsVisibleIndex(index))
    }, 600)
  }, [
    dispatch,
    enabledAutoAddSiz,
    event?.value,
    getDangersSearchedProtectionMeansQuery,
    index,
    protectionMeansState?.prefilled,
  ])

  const closeProtectionMeans = useCallback(() => {
    dispatch(setProtectionMeansIsVisibleIndex(null))
  }, [dispatch])

  return {
    openProtectionMeans,
    closeProtectionMeans,
    protectionMeansIsLoading,
  }
}

export default useProtectionMeansModal
